import { ProposalModel } from './Proposal';
import { MemberModel } from './Member';

export * from './Proposal';
export * from './Member';

export const proposal = new ProposalModel();
export const member = new MemberModel();
